import Reveal from "@/components/base/Reveal";
import { guideSteps } from "@/mocks/siteContent";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-20 w-full bg-secondary-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-5">
            <div className="w-full h-[280px] md:h-[400px] rounded-2xl overflow-hidden border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20desk%20scene%20with%20notebook%2C%20magnifying%20glass%20and%20a%20cup%20of%20tea%2C%20warm%20cream%20and%20soft%20pink%20tones%2C%20editorial%20flat%20lay%2C%20calm%20and%20refined%20aesthetic&width=900&height=700&seq=natsume-guide-13&orientation=landscape"
                alt="信息辨别指南配图，桌面与放大镜"
                title="网络信息辨别指南"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={100}>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-secondary-500"></span>
              <span className="font-label text-xs md:text-sm tracking-widest text-secondary-700 uppercase">
                How to verify
              </span>
            </div>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
              吃瓜之前，先学会辨别信息
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              关于「夏目彩春黑料」的说法真假混杂，与其逐条争论，不如掌握一套通用的判断方法。下面四步能帮你过滤掉大部分噪音。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {guideSteps.map((s) => (
                <div
                  key={s.step}
                  className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-900 flex items-center justify-center">
                      <i className={`${s.icon} text-xl`}></i>
                    </span>
                    <span className="font-heading font-bold text-2xl text-background-300">
                      {s.step}
                    </span>
                  </div>
                  <h3 className="mt-3.5 text-sm md:text-base font-semibold text-foreground-950">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}